import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table1 from "./components/Factors/Table/Table1";
import Table2 from "./components/Factors/Table/Table2";
import Table3 from "./components/Factors/Table/Table3";
import { useState } from "react";

const PageG1 = ({ reload }) => {
    const [educationScore, setEducationScore] = useState("")
    const [experienceScore, setExperienceScore] = useState("")
    const [tavanmadihaScore, setTavanmadihaScore] = useState("")
    return (
        <>
            <Page pageNumber={25}>
                <p className="text-black text-justify py-6">
                    گریدینگ شغل به فرآیند طبقه‌بندی و رتبه‌بندی مشاغل بر اساس سطح مسئولیت، پیچیدگی، مهارت مورد نیاز و ارزش سازمانی آن‌ها اشاره دارد. این نظام، پایه‌ای برای تعیین حقوق و مزایا، مسیر ارتقاء، و مقایسه منصفانه بین مشاغل مختلف فراهم می‌سازد. گریدینگ معمولاً با استفاده از مدل‌های استاندارد مانند Hay، G20، Mercer  یا مدل‌های بومی انجام می‌شود. درج این بخش به ایجاد ساختار شفاف و عادلانه در مدیریت منابع انسانی کمک می‌کند.
                </p>
                <HeaderFactors
                    numberFactors="عامل اول"
                    titelFactors="تحصیلات"
                    maxValue="200"
                    jsValue={educationScore}
                />
                <ExplainFactor
                    text="مجموعه معلومات لازم جهت تصدی و انجام وظایف هر شغل که از طریق دوره های
          آموزشی فرد در مدارس و دانشگاه ها بدست می آید."
                />

                <Table1 educationScore={educationScore} setEducationScore={setEducationScore} reload={reload} />
                <SpaceBetweenTables />
                <HeaderFactors
                    numberFactors="عامل دوم"
                    titelFactors="تجربیات"
                    maxValue="120"
                    jsValue={experienceScore}
                />
                <ExplainFactor
                    text="مدت زمانی است که جهت آشنایی با روش های کار از طریق انجام امور مربوط به وظایف هر شغل بدست
                    می آید."
                />
                <Table2 experienceScore={experienceScore} setExperienceScore={setExperienceScore} reload={reload} />
                <SpaceBetweenTables />
                <HeaderFactors
                    numberFactors="عامل سوم"
                    titelFactors="گواهينامه های مهارتی"
                    maxValue="30"
                    jsValue={tavanmadihaScore}
                />
                <ExplainFactor
                    text="به مجموعه امتیازهای دوره های آموزشی گذرانده شده حین خدمت، بر اساس گواهینامه های معتبر ارائه شده
                    اشاره دارد."
                />
                <Table3 tavanmadihaScore={tavanmadihaScore} setTavanmadihaScore={setTavanmadihaScore} reload={reload} />
            </Page>
        </>
    );
};

export default PageG1;
